import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ExpansionPanel, InputField } from '@/components/common';
import { useCompanyAnnualStore } from '@/store/audit/companyAnnualStore';
import type { CompanyAnnual } from '@/services/accountService/companyAnnualService';

type Props = {
  annualId: number;
  onChange?: (patch: Partial<CompanyAnnual>) => void;
};

export default function EpSmallCashConfirmation({ annualId, onChange }: Props) {
  const store = useCompanyAnnualStore();
  const [local, setLocal] = useState<{ pettyCashConfirmation: string; pettyCashAmount?: number }>({ pettyCashConfirmation: '', pettyCashAmount: undefined });

  useEffect(() => {
    let mounted = true;
    (async () => {
      const v = await store.getSmallCashConfirmationInfo(annualId);
      if (!mounted) return;
      setLocal(v);
    })();
    return () => { mounted = false; };
  }, [annualId, store]);

  const emit = (patch: Partial<typeof local>) => {
    const next = { ...local, ...patch };
    setLocal(next);
    onChange?.(patch as Partial<CompanyAnnual>);
  };

  return (
    <ExpansionPanel title="Small Cash Confirmation (小額現金詢證)">
      <Grid container spacing={0.5}>
        <Grid size={6 as any}>
          <InputField fullWidth variant="outlined" label="Cash Confirmation (現金詢證函)" value={local.pettyCashConfirmation} onChange={(e) => emit({ pettyCashConfirmation: e.target.value })} />
        </Grid>
        <Grid size={6 as any}>
          <InputField fullWidth type="money" variant="outlined" label="Cash Confirmation Amount (現金詢證金額)" value={local.pettyCashAmount ?? ''} onChange={(e) => emit({ pettyCashAmount: e.target.value as any })} onBlur={(e) => {
            const raw = String(e.target.value ?? '').replace(/,/g, '').trim();
            const n = raw === '' || isNaN(Number(raw)) ? 0 : Number(raw);
            emit({ pettyCashAmount: n as any });
          }} />
        </Grid>
      </Grid>
    </ExpansionPanel>
  );
}
